import axios from "axios";

import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getAdvanceAndInvoicesByFilters = async(params) => {

  const token = await authHeader();

    const url = `${ baseUrl }/advances-invoices/list`;
    return axios
      .get(url, {
        params: params,
        headers: token 
        }
      )
      .then(response => {
        return response.data;
       }
       )
  };

const getAdvanceAndInvoiceDetail = async(reference, importWithVat) => {

  const token = await authHeader();

    const url = `${ baseUrl }/advances-invoices/detail`;
    return axios
      .get(url, {
        params: {reference, importWithVAT:importWithVat},
        headers: token 
        }
      )
      .then(response => {
        return response.data;
        }
        )
  };
const downloadAdvanceandInvoicesDetaildataXlsx = async (data, an8) =>{
  const token = await authHeader();
  const url = `${baseUrl}/advances-invoices/excel/detail/${an8}`;

  return axios.post(url, data, {
    headers:token
  }).then((response)=>{
    return response.data
  })
}
const downloadAdvanceandInvoicesdataXlsx = async (data, an8) =>{
  const token = await authHeader();
  const url = `${baseUrl}/advances-invoices/excel/header/${an8}`;

  return axios.post(url, data, {
    headers:token
  }).then((response)=>{
    return response.data
  })
}

  export default {
    getAdvanceAndInvoicesByFilters,
    getAdvanceAndInvoiceDetail,
    downloadAdvanceandInvoicesdataXlsx,
    downloadAdvanceandInvoicesDetaildataXlsx
  }